import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import type BaseFile from '@/modules/common/models/file/base-file.ts';
import type { IBaseFile } from '@/modules/common/models/file/base-file.ts';

export type FileRenameContext = 'master' | 'document';

type State = {
  isOpen: boolean;
  file: BaseFile | null;
  files: IBaseFile[];
  context: FileRenameContext | null;
  anchor: HTMLElement | null;
};

export const useFileRenameStore = defineStore(StoreId.FileRename, {
  state: (): State => ({
    isOpen: false,
    file: null,
    files: [],
    context: null,
    anchor: null,
  }),
  actions: {
    open(
      file: BaseFile,
      files: IBaseFile[] = [],
      context: FileRenameContext = 'master',
      anchor: HTMLElement | null = null
    ) {
      this.file = file;
      this.files = files;
      this.context = context;
      this.anchor = anchor;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    apply(name: string, comment: string) {
      const file = this.file;
      if (!file) {
        return;
      }

      if (name !== file.name) {
        file.rename(name);
      }

      file.setComment(comment);
    },
  },
});
